<template>
  <div>Dashboard...</div>
</template>

<script>
export default {
  name: 'Dashboard',
  props: [],
  components: {},
  data() {
    return {};
  },

  created() {},

  watch: {},

  methods: {},
};
</script>

<style scoped></style>
